module.exports = __webpack_public_path__ + "img/dish-outdoors-white.8fe59ce4.svg";